import { convertTreeDataOrdinances } from '@fs/zion-ordinances-reserve'
import type Cache from '@fs/zion-cache'
import type { Ordinances, TreeDataOrdinances } from '@fs/zion-tree-types'
import { fetcher } from '../useSwrRequest'
import type { WrappedResponse } from './readWrappedDataBE'
import { unwrappedResponse } from './readWrappedDataBE'

/**
 * Reads ordinances from tree-data backend and converts it to the format required by the frontend.
 */
export async function readOrdinances(url: string, cache?: Cache): Promise<Ordinances | undefined> {
  const res = await fetcher<WrappedResponse<TreeDataOrdinances>>(url, cache)
  const unwrappedData = unwrappedResponse(res)
  return unwrappedData ? convertTreeDataOrdinances(unwrappedData) : undefined
}
